import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { SEOHead, seoConfigs } from "@/components/SEOHead";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <SEOHead {...seoConfigs.notFound} />
      <div className="flex min-h-screen items-center justify-center bg-background pb-bottom-nav lg:pb-0">
        <div className="text-center">
          <h1 className="mb-4 text-6xl font-bold text-primary">404</h1>
          <p className="mb-6 text-xl text-muted-foreground">Oops! Page not found</p>
          <Link to="/" className="inline-flex items-center gap-2 text-primary underline hover:text-primary/80 transition-colors">
            Return to ChopperSwap Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
